import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

const UtilityBillPayments = () => {
  // Features data
  const features = [
    {
      icon: "🔌",
      title: "Electricity Bills",
      description:
        "Pay electricity bills for all major state and private discoms across India.",
    },
    {
      icon: "💧",
      title: "Water Bills",
      description:
        "Support for municipal water boards and private water supply companies.",
    },
    {
      icon: "🔥",
      title: "Gas Bills",
      description:
        "PNG and cylinder booking payments for all major gas distributors.",
    },
    {
      icon: "🌐",
      title: "Broadband & Landline",
      description:
        "Internet, landline, and postpaid mobile bills from top service providers.",
    },
    {
      icon: "📚",
      title: "Education Fees",
      description: "School, college, and coaching institute fee payments.",
    },
    {
      icon: "🛡️",
      title: "Secure & Fast",
      description:
        "BBPS-certified platform with instant confirmation and secure transactions.",
    },
  ];

  // Biller categories (icons and names)
  const billers = [
    {
      category: "Electricity",
      examples: "BESCOM, TPDDL, MSEDCL, TANGEDCO",
      icon: "⚡",
    },
    {
      category: "Water",
      examples: "Bangalore Water, Delhi Jal Board, Chennai Metro Water",
      icon: "💧",
    },
    { category: "Gas", examples: "IGL, MGL, Adani Gas, GAIL", icon: "🔥" },
    {
      category: "Broadband",
      examples: "Jio, Airtel, ACT, Hathway",
      icon: "🌐",
    },
    { category: "DTH", examples: "Tata Play, Airtel DTH, Dish TV", icon: "📡" },
    {
      category: "Education",
      examples: "VIT, Amity, FIITJEE, Aakash",
      icon: "📚",
    },
  ];

  return (
    <React.Fragment>
      <Header variant="light" />
      <div className="service-page utility-page">
        <Helmet>
          <title>Utility Bill Payments - Panmitra Online Services</title>
          <meta
            name="description"
            content="Pay electricity, water, gas, broadband, and more via Bharat Connect (BBPS). Agents earn high commissions. Instant processing, secure platform."
          />
        </Helmet>

        <div className="body-overlay"></div>

        <main>
          {/*===== HERO AREA STARTS =======*/}
          <div
            className="about-header-area"
            style={{
              backgroundImage: "url(assets/img/bg/inner-header.png)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-7 m-auto">
                  <div className="about-inner-header heading9 text-center">
                    <h1>Utility Bill Payments</h1>
                    <a href="/">
                      Home <i className="fa-solid fa-angle-right" />{" "}
                      <span>Utility Bill Payments</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*===== SERVICE OVERVIEW =====*/}
          <section className="service-overview sp1">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="overview-content heading2">
                    <h5>BBPS – Bharat Connect</h5>
                    <h2>One Platform for All Bill Payments</h2>
                    <p>
                      Panmitra offers a comprehensive utility bill payment
                      solution through
                      <strong> Bharat Connect (formerly BBPS)</strong>. Agents
                      can pay electricity, water, gas, broadband, DTH, and even
                      educational fees – all from a single dashboard. With a
                      robust API and an easy-to-use interface, you can serve
                      customers faster and earn attractive commissions.
                    </p>
                    <ul className="feature-list">
                      <li>
                        <i className="fa-solid fa-circle-check text-primary"></i>{" "}
                        1500+ billers across India
                      </li>
                      <li>
                        <i className="fa-solid fa-circle-check text-primary"></i>{" "}
                        Instant payment confirmation
                      </li>
                      <li>
                        <i className="fa-solid fa-circle-check text-primary"></i>{" "}
                        Secure BBPS-certified gateway
                      </li>
                      <li>
                        <i className="fa-solid fa-circle-check text-primary"></i>{" "}
                        Real-time transaction tracking
                      </li>
                    </ul>
                    <div className="btn-area mt-4">
                      <a href="/contact-us" className="header-btn11">
                        Start Earning Now{" "}
                        <i className="fa-solid fa-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="overview-image text-center">
                    <img
                      src="/images/bharat-connect-banner.jpg"
                      alt="Utility Bill Payments"
                      className="img-fluid rounded-4 shadow"
                      onError={(e) => (e.target.style.display = "none")}
                    />
                    {/* <div
                      className="fallback-icon"
                      style={{ fontSize: "10rem", color: "#dee2e6" }}
                    >
                      <i className="fa-solid fa-file-invoice"></i>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/*===== KEY FEATURES =====*/}
          <section className="features-grid sp2 bg2">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 m-auto text-center">
                  <div className="heading2">
                    <h5>Why Agents Love Panmitra</h5>
                    <h2>Comprehensive Bill Payment Suite</h2>
                    <p>
                      From electricity to education – we cover all your
                      customers' needs.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row g-4 mt-4">
                {features.map((feature, idx) => (
                  <div key={idx} className="col-lg-4 col-md-6">
                    <div className="feature-card">
                      <div className="feature-icon">{feature.icon}</div>
                      <h3>{feature.title}</h3>
                      <p>{feature.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/*===== SUPPORTED BILLERS =====*/}
          <section className="operators-section sp1">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 m-auto text-center">
                  <div className="heading2">
                    <h5>Wide Coverage</h5>
                    <h2>Supported Billers</h2>
                    <p>
                      We integrate with all major utility providers across the
                      country.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row g-4 mt-4">
                {billers.map((item, idx) => (
                  <div key={idx} className="col-lg-4 col-md-6">
                    <div className="biller-card">
                      <div className="biller-header">
                        <span className="biller-icon">{item.icon}</span>
                        <h4>{item.category}</h4>
                      </div>
                      <p className="biller-examples">{item.examples}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/*===== HOW IT WORKS =====*/}
          <section className="how-it-works sp2 bg2">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 m-auto text-center">
                  <div className="heading2">
                    <h5>Simple Process</h5>
                    <h2>How Bill Payment Works</h2>
                    <p>Three easy steps to serve your customers</p>
                  </div>
                </div>
              </div>
              <div className="row mt-5">
                <div className="col-md-4">
                  <div className="step-card">
                    <div className="step-number">1</div>
                    <h4>Select Biller</h4>
                    <p>
                      Choose from electricity, water, gas, broadband, DTH, or
                      education categories.
                    </p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="step-card">
                    <div className="step-number">2</div>
                    <h4>Enter Details</h4>
                    <p>
                      Input customer's account number/consumer ID and verify the
                      bill amount.
                    </p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="step-card">
                    <div className="step-number">3</div>
                    <h4>Confirm Payment</h4>
                    <p>
                      Make payment from your wallet and get instant confirmation
                      receipt.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/*===== CTA SECTION =====*/}
          <section
            className="cta5-section-area sp1"
            style={{
              backgroundImage: "url(assets/img/bg/header-bg5.png)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-8 m-auto text-center">
                  <div className="cta-content heading2">
                    <h2 className="text-white">
                      Ready to simplify bill payments?
                    </h2>
                    <p className="text-white">
                      Join Panmitra today and offer your customers a seamless
                      bill payment experience.
                    </p>
                    <div className="btn-area mt-4 d-flex justify-content-center flex-wrap gap-3">
                      <a href="/contact-us" className="header-btn11">
                        Become an Agent{" "}
                        <i className="fa-solid fa-arrow-right"></i>
                      </a>
                      <a
                        href="https://developers.instantpanmitra.com"
                        target="_blank"
                        className="header-btn10 text-white"
                      >
                        Explore APIs <i className="fa-solid fa-arrow-right" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>

      <Footer hideCTA={true} />

      {/* Embedded CSS */}
      <style>{`
        .service-page {
          overflow-x: hidden;
        }
        .service-overview {
          background-color: #fff;
        }
        .overview-content .feature-list {
          list-style: none;
          padding: 0;
          margin: 20px 0 0;
        }
        .overview-content .feature-list li {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 10px;
          font-size: 1rem;
          color: #334155;
        }
        .overview-content .feature-list i {
          color: #10b981;
          font-size: 1.3rem;
        }
        .features-grid {
          background-color: #f9fafc;
        }
        .feature-card {
          background: #fff;
          border-radius: 20px;
          padding: 30px 25px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
          transition: transform 0.3s ease;
          height: 100%;
          text-align: center;
        }
        .feature-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
        }
        .feature-icon {
          font-size: 3rem;
          margin-bottom: 20px;
        }
        .feature-card h3 {
          font-size: 1.4rem;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 15px;
        }
        .feature-card p {
          color: #4b5563;
          line-height: 1.6;
        }
        .biller-card {
          background: #fff;
          border-radius: 16px;
          padding: 20px;
          box-shadow: 0 5px 15px rgba(0,0,0,0.05);
          transition: all 0.2s ease;
          border: 1px solid #eef2f6;
          height: 100%;
        }
        .biller-card:hover {
          border-color: #f39c12;
          box-shadow: 0 8px 20px rgba(243,156,18,0.1);
        }
        .biller-header {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 10px;
        }
        .biller-icon {
          font-size: 2rem;
        }
        .biller-header h4 {
          font-size: 1.3rem;
          font-weight: 600;
          color: #1e293b;
          margin: 0;
        }
        .biller-examples {
          color: #4b5563;
          margin: 0;
          font-size: 0.95rem;
          line-height: 1.5;
        }
        .step-card {
          text-align: center;
          padding: 30px 20px;
          background: #fff;
          border-radius: 20px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
          height: 100%;
        }
        .step-number {
          width: 60px;
          height: 60px;
          background: #f39c12;
          color: #fff;
          font-size: 2rem;
          font-weight: 700;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 20px;
        }
        .step-card h4 {
          font-size: 1.3rem;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 15px;
        }
        .step-card p {
          color: #4b5563;
          line-height: 1.6;
        }
        .service-cta {
          background-color: #f8fafc;
          border-radius: 40px 40px 0 0;
        }
        .fallback-icon {
          opacity: 0.3;
        }
        .btn-area .header-btn10 {
          background: transparent;
          border: 2px solid #f39c12;
          color: #1e293b;
          padding: 12px 30px;
          border-radius: 50px;
          font-weight: 600;
          transition: all 0.3s ease;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }
        .btn-area .header-btn10:hover {
          background: #f39c12;
          color: #fff;
        }
        @media (max-width: 768px) {
          .feature-card, .step-card, .biller-card {
            padding: 20px;
          }
          .biller-header {
            flex-direction: column;
            text-align: center;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default UtilityBillPayments;
